import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Satisfaction/Load',
      params,
    });
  },
  LoadClient(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Satisfaction/LoadClient',
      params,
    });
  },
  ChangeEnable(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Satisfaction/ChangeEnable',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Satisfaction/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Satisfaction/Add',
      data,
    });
  },
  Copy(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Satisfaction/Copy',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Satisfaction/Update',
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Satisfaction/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
